import { useEffect } from 'react'

import { useAppConfigStore } from '@/stores/app-store-config/appConfigStore'
import { AppConfigProps } from '@/stores/app-store-config/types'

export const useAppInit = (props: AppConfigProps) => {
	const setAppConfigState = useAppConfigStore.use.setAppConfigState()
	const isStoreRdy = useAppConfigStore.use.rdy()

	useEffect(() => {
		setAppConfigState(props)
	}, [setAppConfigState, props])

	return { isStoreRdy }
}
